import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import pxToRem from 'assets/theme/function/px-to-rem';
import { initialListData } from 'pages/avatar-systems/index';
import { AvatarSystemListRequest } from 'types/avatar-system/avatar-system';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    setDataAvatarRequestList?: React.Dispatch<
        React.SetStateAction<AvatarSystemListRequest>
    >;
    avatarCategory?: string[];
}

const FilterAvatarSystem: React.FC<Props> = (props: Props) => {
    const { setDataAvatarRequestList, avatarCategory } = props;
    const { handleSubmit, control, reset } = useForm<AvatarSystemListRequest>();

    const onSubmit = (values: AvatarSystemListRequest) => {
        if (setDataAvatarRequestList) {
            setDataAvatarRequestList((prevState) => ({
                ...prevState,
                avatarName: values.avatarName,
                avatarCategory: values.avatarCategory,
            }));
        }
    };

    const resets = () => {
        reset();
        if (setDataAvatarRequestList) {
            setDataAvatarRequestList(initialListData);
        }
    };
    return (
        <Box
            pt={pxToRem(10)}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <Box display={'flex'} flexBasis={'100%'}>
                <Controller
                    name="avatarName"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Avatar Name'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '30%' }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Avatar Category</InputLabel>
                    <Controller
                        name="avatarCategory"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Avatar Type"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Avatar Category"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {avatarCategory?.map((status) => (
                                    <MenuItem value={status} key={status}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
            </Box>

            <Box display={'flex'} alignItems={'center'} ml={pxToRem(20)}>
                <Button
                    sx={{ mr: pxToRem(20), px: pxToRem(20) }}
                    variant={'contained'}
                    type={'submit'}
                >
                    Search
                </Button>
                <Button
                    sx={{ px: pxToRem(20) }}
                    variant={'contained'}
                    color={'secondary'}
                    onClick={resets}
                >
                    Clear
                </Button>
            </Box>
        </Box>
    );
};

export default FilterAvatarSystem;
